// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stock-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 300px;
}

.stock-module {
  margin-bottom: 16px;
}

.stock-module-title {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 8px;
  padding-bottom: 4px;
  border-bottom: 1px solid #ddd;
}

.stock-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 0;
}

/* .stock-item {
  display: flex;
  align-items: center;
  gap: 10px;

  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;

  user-select: none;
  transition: background-color 0.15s ease;
} */

.stock-item:hover {
  background-color: #f2f4f7;
}

.stock-item input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.stock-item input[type="checkbox"]:checked + span {
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/web/component/UserStock/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;;;;;;;;;;;GAWG;;AAEH;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".stock-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  max-width: 300px;\r\n}\r\n\r\n.stock-module {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.stock-module-title {\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  margin-bottom: 8px;\r\n  padding-bottom: 4px;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.stock-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 2px 0;\r\n}\r\n\r\n/* .stock-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n\r\n  padding: 6px 10px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n\r\n  user-select: none;\r\n  transition: background-color 0.15s ease;\r\n} */\r\n\r\n.stock-item:hover {\r\n  background-color: #f2f4f7;\r\n}\r\n\r\n.stock-item input[type=\"checkbox\"] {\r\n  width: 16px;\r\n  height: 16px;\r\n  cursor: pointer;\r\n}\r\n\r\n.stock-item input[type=\"checkbox\"]:checked + span {\r\n  font-weight: 600;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
